import React, { FunctionComponent } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { theme } from '/src/assets/theme';
import { useTranslation } from 'react-i18next';
import { links } from '/src/domain/shared/links';

export const TeamBuildingBanner: FunctionComponent = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <a
      className={classes.container}
      href={
        `${links.origin}/teambuilding?utm_source=s10&utm_medium=banner&utm_campaign=startreg`
      }
    >
      <div className={classes.bannerHeader}>
        {t('teamBuildingBannerQuestion')}
      </div>
      <div className={classes.bannerDescription}>
        {t('teamBuildingBannerDescription')}
      </div>
      <div className={classes.bannerAction}>{t('teamBuildingBannerAction')}</div>
    </a>
  );
};

const useStyles = makeStyles((muiTheme) => ({
  container: {
    background: `url(${require('../../assets/icons/team_building_background.png')}) no-repeat`,
    backgroundPosition: 'center right',
    backgroundSize: 'cover',
    [muiTheme.breakpoints.up('sm')]: {
      width: 'calc(100% - 3rem)',
    },
    width: '100%',
    height: '20rem',
    margin: '1.5rem auto',
    position: 'relative',
    display: 'block',
  },
  bannerHeader: {
    color: theme.primaryColor,
    padding: '0.5rem 4.5rem 0.5rem 1.5rem',
    fontSize: '1rem',
    fontWeight: 500,
    background: `url(${require('../../assets/icons/white_rect.svg')})`,
    display: 'inline-block',
    backgroundPositionX: 'right',
    backgroundSize: 'cover',
    position: 'absolute',
    left: 0,
    top: '1.5rem',
  },
  bannerDescription: {
    position: 'absolute',
    color: theme.WHITE_COLOR,
    lineHeight: '1.5rem',
    whiteSpace: 'pre-line',
    left: '2rem',
    top: '50%',
    transform: 'translateY(-50%)',
    fontSize: '1.15rem',
  },
  bannerAction: {
    color: theme.secondaryColor,
    padding: '0.5rem 1.5rem 0.5rem 3rem',
    fontSize: '1rem',
    fontWeight: 500,
    background: `url(${require('../../assets/icons/white_rect_right.svg')})`,
    display: 'inline-block',
    backgroundPositionX: 'left',
    backgroundSize: 'cover',
    position: 'absolute',
    right: 0,
    bottom: '1.5rem',
    textAlign: 'right',
  },
}));
